// Left sidebar nav stub.
//
// Placeholder link items only. Route paths are wired but each destination
// is a placeholder card that the visual pass will replace.
import type { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';

interface SidebarLink {
  to: string;
  label: string;
}

const NAV_LINKS: SidebarLink[] = [
  { to: '/my-work', label: 'My Work' },
  { to: '/my-credit', label: 'My Credit' },
  { to: '/manager', label: 'Manager' },
  { to: '/coaching', label: 'Coaching' },
];

export function Sidebar(): ReactNode {
  return (
    <nav
      aria-label="Primary sales workspace navigation"
      style={{
        borderRight: '1px solid #d0d0d0',
        padding: '16px 12px',
        minWidth: 180,
      }}
    >
      <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
        {NAV_LINKS.map((link) => (
          <li key={link.to} style={{ marginBottom: 8 }}>
            <NavLink
              to={link.to}
              style={({ isActive }) => ({
                display: 'block',
                padding: '6px 8px',
                textDecoration: 'none',
                borderRadius: 4,
                background: isActive ? '#eeeeee' : 'transparent',
                color: '#111',
              })}
            >
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
